// src/pages/RegisterStepTwo.tsx
import React, { useEffect } from "react";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setStepTwoData } from "../forms/registrationSlice";
import { REGISTRATION_STEP_TWO } from "./Validations";

const RegisterStepTwo = ({ onNext }: { onNext: () => void }) => {
  const dispatch = useDispatch();

  const inviteToken = localStorage.getItem("supervisorInviteToken");

  const formik = useFormik({
    initialValues: {
      role: inviteToken ? "SUPERVISOR" : "ASSIGNOR",
    },
    validationSchema: REGISTRATION_STEP_TWO,
    onSubmit: (values) => {
      dispatch(setStepTwoData(values));
      onNext();
    },
  });

  useEffect(() => {
    if (inviteToken) {
      formik.setFieldValue("role", "SUPERVISOR");
    }
  }, [formik, inviteToken]);

  return (
    <div className="w-[calc(100%*5/9)] flex flex-col justify-center">
      <div className="w-1/2 self-center">
        <h2 className="mb-8 text-3xl font-bold">Sign up to Build Connect</h2>
        <p className="mb-8 text-gray-500">Please, pick your role to continue.</p>
        <form onSubmit={formik.handleSubmit}>
          <div className="flex flex-col">
            {!inviteToken && (
              <>
                {/* Contractor */}
                <label className={`relative mb-4 flex justify-between px-6 py-8 border-2 rounded-lg bg-white ${formik.values.role === "CONTRACTOR" ? "border-orange-500 bg-gray-100" : ""}`}>
                  <div className="flex flex-col">
                    <span className="text-l">I’m a contractor</span>
                    <span className="text-gray-500 text-sm">I’m looking to develop properties</span>
                  </div>
                  <input
                    type="radio"
                    name="role"
                    value="CONTRACTOR"
                    checked={formik.values.role === "CONTRACTOR"}
                    onChange={formik.handleChange}
                  />
                </label>

                {/* Assignor */}
                <label className={`relative mb-4 flex justify-between px-6 py-8 border-2 rounded-lg bg-white ${formik.values.role === "ASSIGNOR" ? "border-orange-500 bg-gray-100" : ""}`}>
                  <div className="flex flex-col">
                    <span className="text-l">I’m an assignor</span>
                    <span className="text-gray-500 text-sm">I have a project I want to develop</span>
                  </div>
                  <input
                    type="radio"
                    name="role"
                    value="ASSIGNOR"
                    checked={formik.values.role === "ASSIGNOR"}
                    onChange={formik.handleChange}
                  />
                </label>
              </>
            )}

            {/* Supervisor - always shown */}
            <label className={`relative mb-8 flex justify-between px-6 py-8 border-2 rounded-lg bg-white ${formik.values.role === "SUPERVISOR" ? "border-orange-500 bg-gray-100" : ""}`}>
              <div className="flex flex-col">
                <span className="text-l">I’m a construction supervisor</span>
                <span className="text-gray-500 text-sm">I’m looking to oversee and manage construction projects</span>
              </div>
              <input
                type="radio"
                name="role"
                value="SUPERVISOR"
                checked={formik.values.role === "SUPERVISOR"}
                onChange={formik.handleChange}
                disabled={!!inviteToken}
              />
            </label>

            {formik.errors.role && <div className="text-red-500">{formik.errors.role}</div>}
          </div>

          <button type="submit" disabled={!formik.isValid} className="blue-button w-full py-3 bg-blue-500 text-white font-semibold rounded-lg">
            Next
          </button>

          <div className="flex justify-center mt-4">
            <small className="mr-2 block text-sm text-gray-500 mt-1">Already have an account?</small>
            <Link className="text-blue-600 nav-link" to={"/login"}>
              Log in
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterStepTwo;
